import React from 'react';
type CommonProps = {
  children: React.ReactNode;
  className?: string;
};
const baseClasses = 'inline-block text-center bg-[#8B2A3B] hover:bg-[#6D202E] text-[#F3E5AB] font-sans font-medium uppercase tracking-[0.2em] py-4 px-8 rounded-full transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-brand-gold focus:ring-offset-2 focus:ring-offset-brand-charcoal';
type ButtonProps = (CommonProps & {
  href: string;
} & React.AnchorHTMLAttributes<HTMLAnchorElement>) | (CommonProps & {
  href?: undefined;
} & React.ButtonHTMLAttributes<HTMLButtonElement>);
export function Button({
  children,
  className = '',
  ...props
}: ButtonProps) {
  if ('href' in props && props.href) {
    const {
      href,
      ...rest
    } = props as {
      href: string;
    } & React.AnchorHTMLAttributes<HTMLAnchorElement>;
    return <a href={href} target="_blank" rel="noopener noreferrer" className={`${baseClasses} ${className}`} {...rest} data-id="element-1">
        {children}
      </a>;
  }
  return <button className={`${baseClasses} ${className}`} {...props as React.ButtonHTMLAttributes<HTMLButtonElement>} data-id="element-2">
      {children}
    </button>;
}